export default {
  root: {
    class: [
      'relative',

      // Alignment
      'inline-flex',
      'align-bottom',

      // Size
      'size-5',

      // Misc
      'cursor-pointer',
      'select-none'
    ]
  },
  box: ({ props, context }) => ({
    class: [
      // Alignment
      'flex',
      'items-center',
      'justify-center',

      // Size
      'size-3',

      // Shape
      'rounded',
      'border-0',

      // Colors
      {
        'border-surface-200 bg-zinc-300 dark:border-surface-700 dark:bg-zinc-800':
          !context.checked && !props.invalid,
        'border-primary bg-primary': context.checked
      },

      // Invalid State
      { 'border-red-500 dark:border-red-400': props.invalid },

      // States
      {
        'cursor-default opacity-60': props.disabled
      },

      // Transitions
      'transition-colors',
      'duration-200'
    ]
  }),
  input: {
    class: [
      // Size
      'size-full',

      // Position
      'absolute',
      'top-0 left-0',
      'z-10',

      // Spacing
      'p-0',
      'm-0',

      // Shape
      'opacity-0',
      'rounded',
      'outline-none',
      'border-0 border-surface-200 dark:border-surface-700',

      // Misc
      'appearance-none',
      'cursor-pointer'
    ]
  },
  icon: {
    class: [
      // Font
      'text-sm leading-none font-bold',

      // Size
      '!size-3',

      // Colors
      'text-white dark:text-surface-900',

      // Transitions
      'transition-all',
      'duration-200'
    ]
  }
}
